import numeral from "numeral";

export const enum Currency {
  MYR = "MYR"
}

export const defaultFormat = "0,0";

export const formatCurrencyText = (currencyText: string) => {
  return currencyText.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

export const convertRupeeToLacs = (value: number) => {
  /* India event prefers format of "INR 1.32 lacs" instead of "INR 132,000" */
  return numeral(value / 100000).format("0.00");
};

export const convertNumeral = (value: number, isLacsFormat: boolean) => {
  if (isLacsFormat) {
    return convertRupeeToLacs(value);
  }
  return numeral(value).format(defaultFormat);
};
